import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { TextInputField } from "../input/TextInputField";
import { TextAreaInputField } from "../input/TextAreaInputField";
import { useForm } from "react-hook-form";
import { Button } from "../input/Button";
import { FormattedMessage, useIntl } from "react-intl";
import { Column } from "../layout/Column";

import ClassicEditor from "../ckeditor";

export function ObjectPopupModal({ onSubmit, onClose, activeObjectPopup }) {
  const intl = useIntl();
  const { isSubmitting, handleSubmit, register, errors } = useForm({
    defaultValues: {
      popup_title: activeObjectPopup.popup_title,
      popup_content: activeObjectPopup.popup_content
    }
  });
  let current_editor;
  const onSubmitHandle = useCallback(
    ({ popup_title, popup_content }) => {
      onSubmit({ popup_title, popup_content: current_editor.getData() });
    },
    [onSubmit, onClose]
  );
  useEffect(() => {
    ClassicEditor
      // Note that you do not have to specify the plugin and toolbar configuration — using defaults from the build.
      .create(document.querySelector("#popup_content"))
      .then(editor => {
        current_editor = editor;
      })
      .catch(error => {
        console.error(error.stack);
      });
  }, []);
  return (
    <Modal
      className="modal_w500"
      title={<FormattedMessage id="object-popup-modal.title" defaultMessage="Object Popup" />}
      beforeTitle={<CloseButton onClick={onClose} />}
    >
      <Column as="form" padding center onSubmit={handleSubmit(onSubmitHandle)}>
        <TextInputField
          name="popup_title"
          placeholder="Popup Title"
          type="text"
          ref={register}
          error={errors.popup_title && errors.popup_title.message}
          fullWidth
        />
        <TextAreaInputField
          name="popup_content"
          id="popup_content"
          autoComplete="off"
          placeholder={intl.formatMessage({
            id: "object-popup-modal.popup_content-placeholder",
            defaultMessage: "Type or paste your content here!"
          })}
          minRows={3}
          ref={register}
          error={errors.popup_content && errors.popup_content.message}
          fullWidth
        />
        <Button type="submit" preset="accept" disabled={isSubmitting}>
          <FormattedMessage id="object-popup-modal.change-object-popup-button" defaultMessage="Change Object Popup" />
        </Button>
      </Column>
    </Modal>
  );
}

ObjectPopupModal.propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  activeObjectPopup: PropTypes.object
};
